import React, { createContext, useState } from "react";
import { ApplyWithoutProfileFormValues } from "./applyWithoutProfileSchema";
import { observer } from "mobx-react-lite";
import { useAdIrelTrel } from "../../jobView/useAdIrelTrel";

export interface ApplyWithoutProfileContextStates {
  formValues: ApplyWithoutProfileFormValues;
  setFormValues: (values: ApplyWithoutProfileFormValues) => void;
  resetFormValues: () => void;
}

export const ApplyWithoutProfileContext = createContext<
  ApplyWithoutProfileContextStates | undefined
>(undefined);

interface ApplyWithoutProfileProviderProps {
  children: React.ReactNode;
}

const _ApplyWithoutProfileProvider = (
  props: ApplyWithoutProfileProviderProps
) => {
  const { children } = props;

  const [formValues, setFormValues] = useState<ApplyWithoutProfileFormValues>({
    applicationText: "",
    consent: false,
    attachments: [],

    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    address: "",
    zipCode: "",
    dob: null,
  });

  const resetFormValues = () => {
    setFormValues({
      applicationText: "",
      consent: false,
      attachments: [],

      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      address: "",
      zipCode: "",
      dob: null,
    });
  };

  return (
    <ApplyWithoutProfileContext.Provider
      value={{ formValues, setFormValues, resetFormValues }}
    >
      {children}
    </ApplyWithoutProfileContext.Provider>
  );
};

export const ApplyWithoutProfileProvider = observer(({ children }) => {
  const { idRelatedResolved, typeRelatedResolved } = useAdIrelTrel({
    idRelated: null,
    typeRelated: null,
  });

  return (
    <_ApplyWithoutProfileProvider
      // clear values when id or type changes
      key={`${idRelatedResolved}:${typeRelatedResolved}`}
    >
      {children}
    </_ApplyWithoutProfileProvider>
  );
});
